import gql from 'graphql-tag';

export const generateDeliveryOrderMutation = gql`
  mutation GenerateDeliveryOrder($deliveryOrderId: ID!) {
    generateDeliveryOrder(deliveryOrderId: $deliveryOrderId) {
      deliveryOrderDocumentGenerationRequestId
    }
  }
`;
